import { RiArrowDropDownLine } from "react-icons/ri";
import { motion, AnimatePresence } from "framer-motion";
import { useState, ReactNode } from "react";

interface DropdownProps {
    title: ReactNode;
    content: ReactNode;
    bgColorOpen?: string;
    bgColorClosed?: string;
    borderColorOpen?: string;
    borderColorClosed?: string;
    textColorOpen?: string;
    textColorClosed?: string;
    iconColorOpen?: string;
    iconColorClosed?: string;
}

const Dropdown = ({ 
    title, 
    content,
    bgColorOpen = 'bg-blue-100',
    bgColorClosed = 'bg-white',
    borderColorOpen = 'border-blue-300',
    borderColorClosed = 'border-gray-200',
    textColorOpen = 'text-blue-600',
    textColorClosed = '',
    iconColorOpen = 'text-blue-600',
    iconColorClosed = ''
}: DropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <motion.div
            className={`p-4 border-2 rounded-md cursor-pointer transition-colors ${isOpen ? `${bgColorOpen} ${borderColorOpen}` : `${bgColorClosed} ${borderColorClosed}`}`}
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="flex justify-between items-center">
                <p className={`font-medium ${isOpen ? textColorOpen : textColorClosed}`}>{title}</p>
                <motion.div
                    transition={{ duration: 0.5 }}
                    animate={{rotate: isOpen? 180 : 0}}
                >
                    <RiArrowDropDownLine size={28} className={isOpen ? iconColorOpen : iconColorClosed} />
                </motion.div>
            </div>

            {/* Animate content expanding */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div 
                        initial={{ height: 0, opacity: 0 }} 
                        animate={{ height: "auto", opacity: 1 }} 
                        exit={{ height: 0, opacity: 0 }} 
                        transition={{ duration: 0.5 }} 
                        className="overflow-hidden"
                    >
                        <p className="mt-4">{content}</p>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

export default Dropdown;